import { Controller } from 'stimulus'

export default class extends Controller {

  static targets = [ "toggler", "cancellableElement" ]

  cancelCreate(event) {
    var new_list_div = event.target.closest(".new-kanban-list");
    new_list_div.parentNode.removeChild(new_list_div);

    var kanban_board = document.querySelector(".kanban-board");
    if (kanban_board.classList.contains("lists-count-4")) {
      kanban_board.classList.remove("lists-count-4");
      kanban_board.classList.add("lists-count-3");
    }
  }

  cancelUpdate(event) {
    const list_header = event.target.closest(".kanban-list-header");
    if (!list_header) return;

    list_header.classList.remove("editing");

    const titleWrapper = list_header.querySelector(".list-title-wrapper");
    if (titleWrapper) titleWrapper.classList.remove("hidden");

    const settings = list_header.querySelector("#kanban-list-settings");
    if (settings) settings.classList.remove("hidden");

    const editForm = list_header.querySelector("form.kanban-title-edit-form");
    if (editForm) editForm.remove();
  }

  showToggler() {
    if (this.hasTogglerTarget) {
      this.togglerTarget.classList.remove("hidden");
    }
  }
}
